import React from "react";
import FormSubmissionTable, { ColumnHeader } from "../formSubmissionsDataGrid";

const GIFFormSubmission: React.FC = () => {
  const columnHeaders: ColumnHeader[] = [
    {
      Column_Name: "Submission ID",
      Field_Name: "Submission_ID",
    },
    {
      Column_Name: "User Email",
      Field_Name: "User_Email",
    },
    {
      Column_Name: "Entry Date",
      Field_Name: "Entry_Date",
    },
    {
      Column_Name: "Company Name",
      Field_Name: "companyName",
    },
    {
      Column_Name: "Unique ID",
      Field_Name: "uniqueId",
    },
  ];

  return <FormSubmissionTable columnHeaders={columnHeaders} formId={1} formName={"GIF"}></FormSubmissionTable>;
};

export default GIFFormSubmission;
